var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.833496,
    y: 0.5,
    width: 47,
    height: 47,
    rx: 9.5,
    stroke: "#FC4949"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.5835 18.582L30.0671 26.9363C29.9351 29.0707 29.8692 30.1379 29.3342 30.9053C29.0696 31.2846 28.7291 31.6048 28.3341 31.8454C27.5352 32.332 26.466 32.332 24.3274 32.332C22.1861 32.332 21.1154 32.332 20.316 31.8444C19.9208 31.6034 19.5802 31.2827 19.3157 30.9027C18.7809 30.1342 18.7164 29.0654 18.5873 26.928L18.0835 18.582",
    stroke: "#FC4949",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8335 18.5846H31.8335M27.7132 18.5846L27.1444 17.4111C26.7665 16.6315 26.5775 16.2417 26.2516 15.9986C26.1793 15.9447 26.1027 15.8968 26.0227 15.8552C25.6617 15.668 25.2286 15.668 24.3622 15.668C23.4742 15.668 23.0302 15.668 22.6632 15.8631C22.5819 15.9063 22.5043 15.9562 22.4312 16.0123C22.1015 16.2652 21.9174 16.6693 21.549 17.4774L21.0443 18.5846",
    stroke: "#FC4949",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.25 27.75V22.75",
    stroke: "#FC4949",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.417 27.75V22.75",
    stroke: "#FC4949",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteButton);
export default __webpack_public_path__ + "static/media/Delete_Button.bdfd729dc8e4bc8639c0fbde7a0cd2a0.svg";
export { ForwardRef as ReactComponent };